import {Spinner} from 'spin.js';
import VueCollapse from 'vue2-collapse';
import * as Cookie from 'js-cookie';
import vSelect from "vue-select";
import Vue from "vue";
import RelatedProductsOrderConfirmation from "./components/RelatedProductsOrderConfirmation.vue";
import TrustedShopStars from "./components/TrustedShopStars.vue";
import AdyenDropIn from "./components/AdyenDropIn.vue";
import SmartphoneSelector from "./components/checkout/SmartphoneSelector.vue";

Vue.use(VueCollapse);

Vue.component('related-products', RelatedProductsOrderConfirmation);
Vue.component('trusted-shop-stars', TrustedShopStars);
Vue.component('adyen-drop-in', AdyenDropIn);
Vue.component('smartphone-selector', SmartphoneSelector);
Vue.component('v-select', vSelect);

if(document.getElementById("checkoutApp")) {
    new Vue({el: '#checkoutApp'});
}

const spinnerOpts = {
    lines: 11,
    length: 29,
    width: 7,
    radius: 19,
    scale: 0.75,
    corners: 1,
    color: '#33b7b0',
    fadeColor: 'transparent',
    opacity: 0.25,
    rotate: 0,
    direction: 1,
    speed: 1,
    trail: 60,
    fps: 20,
    zIndex: 2e9,
    className: 'spinner',
    top: '50%',
    left: '50%',
    shadow: 'none',
    position: 'absolute'
};

const OTHER_COUNTRY_TEXT = 'other';
const PRISMIC_PREFIX = 'prismic';
const PRISMIC_PREFIX_OTHER_COUNTRY = 'prismic-other-country';
const DEVICE_AGE_INPUT_IDS = ['deviceAge_new', 'deviceAge_old'];
const VOUCHER_BUTTON_IDS = ['deleteVoucherCode', 'deleteEmptyVoucher'];
const BIKE_CATEGORY = 'BIKE';
const PRODUCT_DURATION_DAYS = 'DAYS';
const THANKYOU_VOUCHER_COOKIE_TOKEN = 'thankyouvoucher'
const THANKYOU_VOUCHER_TOKEN = 'THANKYOU'

document.addEventListener("DOMContentLoaded", function () {
    let validateVoucherButton = document.getElementById("validate_voucher");
    if (validateVoucherButton) validateVoucherButton.addEventListener("click", refreshPrice, false);

    let voucherField = document.getElementById("voucher");
    if (voucherField) voucherField.addEventListener("keypress", catchEnter(refreshPrice), false);

    if (voucherField && Cookie.get(THANKYOU_VOUCHER_COOKIE_TOKEN)) {
        voucherField.value = THANKYOU_VOUCHER_TOKEN;
    }

    addDatePickers();

    let identicalInsurancePerson = document.getElementById('identicalInsurancePerson');
    let toInsurePerson = document.getElementById('to-insure-person');
    if (identicalInsurancePerson) {
        identicalInsurancePerson.addEventListener('click', function () {
            toInsurePerson.classList.toggle('hidden');
        });
        if (identicalInsurancePerson.checked) {
            toInsurePerson.classList.toggle('hidden');
        }
    }

    let toggle = document.getElementsByClassName('panel-title')[0];
    if (toggle) {
        toggle.addEventListener('click', function () {
            let icon = toggle.getElementsByClassName('glyphicon')[0];
            icon.classList.toggle('glyphicon-plus');
            icon.classList.toggle('glyphicon-minus');
        });
    }

    let voucherCodeDisplay = document.getElementById('voucherSummary');
    if (voucherCodeDisplay && !voucherCodeDisplay.classList.contains('hidden')) {
        updateVoucherField(document.getElementById('voucherCodeApplied').innerHTML.trim());
    }

    VOUCHER_BUTTON_IDS.forEach(function (id) {
        registerVoucherListener(id);
    });
    DEVICE_AGE_INPUT_IDS.forEach(function (id) {
        registerDeviceAgeListener(id);
    });
    checkDeviceAgeExists();

    $('.hoverinfo').popover({
        placement: 'top',
        animation: 'false'
    }).click((e) => e.preventDefault());

    let smartPhoneSepaAddition = document.getElementById('smartphone-addition');
    if (smartPhoneSepaAddition) {
        let sepaPaymentButton = document.querySelector('input[value=sepadirectdebit]');
        let paymentButtons = document.querySelectorAll('.payment-methods input[type=radio]');
        Array.from(paymentButtons).forEach((paymentButton) => {
            paymentButton.addEventListener('change', () => {
                if (paymentButton === sepaPaymentButton && sepaPaymentButton.checked === true) {
                    smartPhoneSepaAddition.classList.remove('hide');
                } else if (paymentButton !== sepaPaymentButton) {
                    smartPhoneSepaAddition.classList.add('hide');
                }
            })
        });
    }

    let personAge = document.getElementById('personAge');
    if (personAge) {
        let insureOtherPerson = document.getElementById('identicalInsurancePerson');
        if (insureOtherPerson) {
            insureOtherPerson.addEventListener('click', addPersonAgeEventListener);
            addPersonAgeEventListener();
        }
    }

    addPreviousInsuranceCollapse();

    let contractDuration = document.getElementById('m&m-contract-date');
    if (contractDuration) {
        let singleDurationSelection = document.getElementById('product-duration-single-selection');
        let startDate = document.getElementById('start-date-selection');

        let sendStartDate = document.getElementById('start_date');
        let sendDurationTimeUnit = document.getElementById('duration_time_unit');
        let sendProductDuration = document.getElementById('product_duration');

        if (singleDurationSelection) {
            singleDurationSelection.addEventListener('change', function () {
                let days = singleDurationSelection.value.split('DAYS')[0];
                sendDurationTimeUnit.value = 'DAYS';
                sendProductDuration.value = days;
                refreshDuration(sendDurationTimeUnit.value, sendProductDuration.value, sendStartDate.value);
            });
        }

        if (startDate) {
            startDate.addEventListener('change', function () {
                if (moment(startDate.value).isValid()) {
                    sendStartDate.value = moment(startDate.value).format('YYYY-MM-DD');
                    refreshDuration(sendDurationTimeUnit.value, sendProductDuration.value, sendStartDate.value);
                }
            });
        }
    }

    if (typeof autoRedeemVoucher !== 'undefined' && hasValue(autoRedeemVoucher)) {
        setVoucherForVoucherField(autoRedeemVoucher);
    } else if (typeof loyaltyVoucher !== 'undefined' && hasValue(loyaltyVoucher)) {
        setVoucherForVoucherField(loyaltyVoucher);
    } else if (typeof orderConfirmationVoucher !== 'undefined' && hasValue(orderConfirmationVoucher)) {
        if (isThankYouVoucherProductSlug(noThankYouVoucherProductSlugs, productName)) {
            setVoucherForVoucherField(orderConfirmationVoucher);
        }
    }

    if (typeof redirectUrl != 'undefined' && redirectUrl)
        redirect(redirectUrl, redirectTimeout);

    const chipnumberTextField = document.querySelector('#chipnumberOfPet');
    const registrationTextField = document.querySelector('#registrationNumber');
    function setTextFieldName(policyAttributeFieldName, textName) {
        policyAttributeFieldName.addEventListener('change', () => {
            if (policyAttributeFieldName.value === '') {
                policyAttributeFieldName.name = `${textName}_text`;
            } else {
                policyAttributeFieldName.name = textName;
            }
        });
    }

    if (chipnumberTextField) {
        setTextFieldName(chipnumberTextField, 'chipnumberOfPet');
    }
    if (registrationTextField) {
        setTextFieldName(registrationTextField, 'registrationNumber');
    }


});

window.addEventListener('load', () => {
    const voucherElement = document.getElementById('voucher');
    if (voucherElement && voucherElement.value) {
        document.getElementById('validate_voucher').click();
    }
})

window.addPersonAgeEventListener = function addPersonAgeEventListener(event) {
    let personAge = document.getElementById('personAge');
    let insureOtherPersonBirthDate = document.getElementById('insure[birthDate]');
    let confirmationPersonBirthDate = document.getElementById('birthDate');

    insureOtherPersonBirthDate.addEventListener('change', function () {
        personAge.value = insureOtherPersonBirthDate.value;
    });
    if (insureOtherPersonBirthDate.value) {
        personAge.value = insureOtherPersonBirthDate.value;
    }
    confirmationPersonBirthDate.addEventListener('change', function () {
        personAge.value = confirmationPersonBirthDate.value;
    });
    if (confirmationPersonBirthDate.value && !insureOtherPersonBirthDate.value) {
        personAge.value = confirmationPersonBirthDate.value;
    }
};

window.toggleTermsOfService = function () {
    $(".terms-of-service").toggleClass("minified");
    let showMoreBtn = $(".show-more-terms");
    let moreText = showMoreBtn.data("more");
    let lessText = showMoreBtn.data("less");
    if ($(".terms-of-service").hasClass("minified")) {
        $(showMoreBtn).text(moreText);
    } else {
        $(showMoreBtn).text(lessText);
    }
}
window.hasValue = function hasValue(voucher) {
    return typeof voucher !== 'undefined' && voucher != null && voucher !== '';
};

window.setVoucherForVoucherField = function setVoucherForVoucherField(value) {
    let voucherField = document.getElementById('voucher');
    if (voucherField) {
        voucherField.value = value;
        let sendVoucherBtn = document.getElementById('validate_voucher');
        if (sendVoucherBtn) {
            sendVoucherBtn.click();
        }
    }
};

window.redirect = function redirect(url, timeout) {
    let target = document.getElementById('spinner');
    let spinner = new Spinner(spinnerOpts).spin(target);
    setTimeout(function () {
        window.location.href = url;
    }, timeout);
};

window.refreshDuration = function refreshDuration(unit, duration, startDate) {
    let endDate = document.getElementById('end_date');
    if (endDate) {
        let endDateValue = moment(startDate).add(duration, unit.toLowerCase());
        endDate.value = endDateValue.format('YYYY-MM-DD');

        let summaryDurationTime = document.querySelector('.summary .duration p.col-xs-12.no-margin.no-padding');
        summaryDurationTime.innerHTML = 'Laufzeit<br>' + moment(startDate).format('DD.MM.YYYY') + ' - ' + endDateValue.format('DD.MM.YYYY');

        refreshPrice();
    }
};

window.addPreviousInsuranceCollapse = function addPreviousInsuranceCollapse() {
    let previousInsured = document.getElementById('previouslyInsured');
    if (previousInsured) {
        let attributesContainer = document.getElementsByClassName('device-informations')[0].querySelector('.col-xs-12.no-padding');
        let attributes = attributesContainer.querySelectorAll('.col-xs-12.no-padding > .col-xs-12.form-group:not(.checkbox):not(.select)');

        previousInsured.addEventListener('click', function () {
            if (previousInsured.checked) {
                Array.from(attributes).forEach(function (attribute) {
                    attribute.classList.remove('hide');
                    let inputs = attribute.getElementsByTagName('input');
                    Array.from(inputs).forEach(function (input) {
                        input.setAttribute('required', 'required');
                    });
                });
            } else {
                Array.from(attributes).forEach(function (attribute) {
                    attribute.classList.add('hide');
                    let inputs = attribute.getElementsByTagName('input');
                    Array.from(inputs).forEach(function (input) {
                        input.removeAttribute('required');
                    });
                });
            }
        });

        Array.from(attributes).forEach(function (attribute) {
            attribute.classList.add('hide');
            let inputs = attribute.getElementsByTagName('input');
            Array.from(inputs).forEach(function (input) {
                if (previousInsured.checked) {
                    input.setAttribute('required', 'required');
                    input.removeAttribute('novalidate');
                } else {
                    input.removeAttribute('required');
                    input.setAttribute('novalidate', 'novalidate');
                }
            });
        });

        if (previousInsured.checked) {
            Array.from(attributes).forEach(function (attribute) {
                attribute.classList.remove('hide');
                let inputs = attribute.getElementsByTagName('input');
                Array.from(inputs).forEach(function (input) {
                    input.setAttribute('required', 'required');
                });
            });
        }
    }
};

window.registerVoucherListener = function registerListener(buttonId = '') {
    let deleteVoucherButton = document.getElementById(buttonId);
    if (deleteVoucherButton) {
        deleteVoucherButton.addEventListener('click', function () {
            let voucher = document.getElementById('voucher');
            voucher.disabled = false;
            voucher.value = '';
            document.getElementById('voucherSummary').className = 'row hidden';
            document.getElementById('voucherScopeType').className = 'row hidden';
            refreshPrice();
        }, false);
    }
};

window.registerDeviceAgeListener = function registerInputListener(inputId = '') {
    let input = document.getElementById(inputId);
    if (input) {
        input.addEventListener('click', function (e) {
            let undamage = document.getElementById('undamagedConfirmed');
            if (e.target.value == 'old')
                undamage.parentElement.getElementsByClassName("attribute-text")[0].innerHTML = confirmDeviceAgeOld + '*';
            else
                undamage.parentElement.getElementsByClassName("attribute-text")[0].innerHTML = confirmDeviceAgeNew + '*';
        }, false);
    }
};

window.submitForm = function submitPaymentForm(id) {
    document.getElementById(id).submit();
};

window.refreshPrice = function refreshPrice() {
    let contractId = document.getElementById('contract_id').value;
    let productId = document.getElementById('product_id').value;
    let qualityId = document.getElementById('quality_id').value;
    let coverageId = document.getElementById('coverage_id').value;
    let salesChannel = document.getElementById('sales_channel').value;
    let productDuration = document.getElementById("product_duration").value;
    let durationTimeUnit = document.getElementById("duration_time_unit").value;
    let voucherVal = document.getElementById('voucher').value.trim();
    let bundleProductId = '';
    let bundleQualityId = '';
    let bundleCoverageId = '';
    if (document.getElementById('bundle_product_id')) {
        bundleProductId = document.getElementById('bundle_product_id').value;
        bundleQualityId = document.getElementById('bundle_quality_id').value;
        bundleCoverageId = document.getElementById('bundle_coverage_id').value;
    }


    cleanVoucherFormErrors();

    if (voucherVal.length == 0) {
        getEmptyVoucherMessage(true);
        return;
    }

    let target = document.getElementById('spinner');
    let spinner = new Spinner(spinnerOpts).spin(target);
    const promises = [];
    if (bundleProductId !== '') {
        promises.push(axios.post('/checkout/refreshPrice', {
            'contractId': contractId,
            'productId': bundleProductId,
            'coverageId': bundleCoverageId,
            'qualityId': bundleQualityId,
            'salesChannel': salesChannel,
            'duration': productDuration,
            'durationTimeUnit': durationTimeUnit,
            'voucherVal': voucherVal,
            'type': 'BUNDLE'
        }))
    }
    promises.push(axios.post('/checkout/refreshPrice', {
        'contractId': contractId,
        'productId': productId,
        'qualityId': qualityId,
        'coverageId': coverageId,
        'salesChannel': salesChannel,
        'duration': productDuration,
        'durationTimeUnit': durationTimeUnit,
        'voucherVal': voucherVal,
        'type': 'BASE'
    }))

    Promise.all(promises).then(function (response) {
        spinner.stop();

        let summedPrice;
        if (bundleProductId !== '') {
            summedPrice = sumPrices(response[0], response[1]);
        } else {
            summedPrice = sumPrices(response[0], null);
        }

        updateRates(summedPrice);
        updateDurations(productDuration, durationTimeUnit);

        if (summedPrice.discountAppliedAmount > 0) {
            toggleVoucher(summedPrice.discountAppliedAmount, voucherVal, true);
            // voucher text for NORMAL scope type
            if (hasValue(summedPrice.voucherScopeTypeText)) {
                showVoucherScopeType(voucherVal, summedPrice.voucherScopeType, summedPrice.voucherScopeTypeText);
            }
        } else {
            toggleVoucher(0, voucherVal, false);
            if (hasValue(summedPrice.voucherScopeTypeText)) {
                showVoucherScopeType(voucherVal, summedPrice.voucherScopeType, summedPrice.voucherScopeTypeText);
            }
        }

        if (summedPrice.dailyPrice === 0 && summedPrice.monthlyPrice === 0 && summedPrice.price === 0) {
            if (contractType === 'SINGLE' || summedPrice.maxApplicablePeriods === null || summedPrice.maxApplicablePeriods === 0) {
                showVoucherPayment();
            } else if (contractType === 'RECURRING') {
                hideSepaPayment();
            }
        } else {
            hideVoucherPayment();
        }

    }).catch(function (error) {
        let emptyVoucherVal = error.response.data.emptyVoucherVal;
        let invalidVoucherVal = error.response.data.invalidVoucherVal;
        let invalidVoucherMessageDurationMonths = error.response.data.invalidVoucherMessageDurationMonths;
        let invalidVoucherMessageDurationYears = error.response.data.invalidVoucherMessageDurationYears;

        if (emptyVoucherVal == true) {
            getEmptyVoucherMessage(true);
        }

        if (invalidVoucherVal == true) {
            getInvalidVoucherMessage(true);
        }

        if (invalidVoucherMessageDurationMonths == true) {
            getInvalidVoucherMessageDurationMonths(true);
        }

        if (invalidVoucherMessageDurationYears == true) {
            getInvalidVoucherMessageDurationYears(true);
        }

        toggleVoucher(0, voucherVal, false);
        document.getElementById('voucher').value = null;
        spinner.stop();
    });
};

function sumPrices(baseProduct, bundleProduct) {
    if (bundleProduct !== null) {
        return {
            "originalPrice": baseProduct.data.originalPrice + bundleProduct.data.originalPrice,
            "price": baseProduct.data.price + bundleProduct.data.price,
            "serviceFee": baseProduct.data.serviceFee + bundleProduct.data.serviceFee,
            "transferFee": baseProduct.data.transferFee + bundleProduct.data.transferFee,
            "maxApplicablePeriods": baseProduct.data.maxApplicablePeriods,
            "discountAppliedAmount": baseProduct.data.discountAppliedAmount + bundleProduct.data.discountAppliedAmount,
            "voucherScopeTypeText": baseProduct.data.voucherScopeTypeText,
            "voucherScopeType": baseProduct.data.voucherScopeType,
            "dailyPrice": baseProduct.data.dailyPrice + bundleProduct.data.dailyPrice,
            "monthlyPrice": baseProduct.data.monthlyPrice + bundleProduct.data.monthlyPrice,
            "insuranceTax": baseProduct.data.insuranceTax + bundleProduct.data.insuranceTax,
            "voucherToken": baseProduct.data.voucherToken,
        }
    }
    return baseProduct.data
}

window.hideSepaPayment = function hideSepaPayment() {
    let paymentMethods = document.querySelector('input[value="sepadirectdebit"]').parentElement.parentElement.parentElement;
    if (paymentMethods) {
        paymentMethods.classList.add('hide');
    }
};

window.showVoucherPayment = function showVoucherPayment() {
    document.querySelectorAll('.payment-methods .hidden').forEach(e => e.classList.remove('hidden'));
    let paymentMethods = document.querySelectorAll('.payment-methods .row > .col-xs-12:not(:last-child)');
    let paymentMethodText = document.querySelector('.payment-methods .row > .col-xs-12:last-child');
    let methodsContainer = document.querySelector('.payment-methods .row');
    if (paymentMethods) {
        Array.from(paymentMethods).forEach(function (paymentMethod) {
            paymentMethod.classList.add('hide');
        });
    }

    if (methodsContainer && paymentMethodText) {
        let voucherWrapper = document.createElement('div');
        voucherWrapper.classList.add('col-xs-12', 'form-group', 'no-margin');
        voucherWrapper.setAttribute('id', 'voucher-payment-wrapper');
        let radioWrapper = document.createElement('div');
        radioWrapper.classList.add('radio');
        let label = document.createElement('label');
        let input = document.createElement('input');
        input.setAttribute('name', 'method');
        input.setAttribute('type', 'radio');
        input.setAttribute('value', 'voucher');
        input.setAttribute('checked', 'checked');
        label.innerHTML = 'Gutschein';
        label.insertAdjacentElement('afterbegin', input);
        radioWrapper.appendChild(label);
        voucherWrapper.appendChild(radioWrapper);
        methodsContainer.insertBefore(voucherWrapper, paymentMethodText);
    }
};

window.hideVoucherPayment = function hideVoucherPayment() {
    let paymentMethods = document.querySelectorAll('.payment-methods .row > .col-xs-12:not(:last-child)');
    if (paymentMethods) {
        Array.from(paymentMethods).forEach(function (paymentMethod) {
            paymentMethod.classList.remove('hide');
        });
    }

    let voucherWrapper = document.getElementById('voucher-payment-wrapper');
    if (voucherWrapper) {
        voucherWrapper.parentNode.removeChild(voucherWrapper);
    }
};

window.toggleVoucher = function toggleVoucher(discountAppliedAmount, voucherCode, show) {
    let formatter = Intl.NumberFormat('de-DE', {minimumFractionDigits: 2});
    if (show) {
        document.getElementById('voucherSummary').className = 'col-xs-12 no-padding bottom-buffer open';
        document.getElementById('voucherCodeApplied').innerText = voucherCode;
        document.getElementById('discountAppliedAmount').innerText = formatter.format(discountAppliedAmount);
        updateVoucherField(voucherCode);
        document.getElementById('voucherSummary').scrollIntoView();
        document.getElementById("deleteEmptyVoucher").className = 'deleteVoucher pull-right hidden';
    } else {
        document.getElementById('voucherSummary').className = 'col-xs-12 no-padding hidden';
        document.getElementById("deleteEmptyVoucher").className = 'deleteVoucher pull-right open';
    }
};

window.showVoucherScopeType = function showVoucherScopeType(voucherCode, scopeType, translationText) {
    document.getElementById('voucherSummary').classList.remove('bottom-buffer');
    document.getElementById('voucherScopeType').className = 'col-xs-12 no-padding bottom-buffer open';
    document.getElementById('voucherText').innerHTML = translationText;
    updateVoucherField(voucherCode);
    document.getElementById('voucherSummary').scrollIntoView();
};

window.getInvalidVoucherMessage = function getInvalidVoucherMessage(invalid) {
    let invalidVoucherMessage = document.getElementById('invalidVoucherMessage');
    let voucherFormGroup = document.getElementById('voucherFormGroup');

    if (invalid) {
        invalidVoucherMessage.classList.remove('hidden');
        voucherFormGroup.classList.add('has-error');
    }
};

window.getEmptyVoucherMessage = function getEmptyVoucherMessage(empty) {
    let emptyVoucherMessage = document.getElementById('emptyVoucherMessage');
    let voucherFormGroup = document.getElementById('voucherFormGroup');

    if (empty) {
        emptyVoucherMessage.classList.remove('hidden');
        voucherFormGroup.classList.add('has-error');
    }
};

window.getInvalidVoucherMessageDurationMonths = function getInvalidVoucherMessageDurationMonths(invalid) {
    let invalidVoucherMessageDurationMonths = document.getElementById('invalidVoucherMessageDurationMonths');
    let voucherFormGroup = document.getElementById('voucherFormGroup');

    if (invalid) {
        invalidVoucherMessageDurationMonths.classList.remove('hidden');
        voucherFormGroup.classList.add('has-error');
    }
};

window.getInvalidVoucherMessageDurationYears = function getInvalidVoucherMessageDurationYears(invalid) {
    let invalidVoucherMessageDurationYears = document.getElementById('invalidVoucherMessageDurationYears');
    let voucherFormGroup = document.getElementById('voucherFormGroup');

    if (invalid) {
        invalidVoucherMessageDurationYears.classList.remove('hidden');
        voucherFormGroup.classList.add('has-error');
    }
};

window.cleanVoucherFormErrors = function cleanVoucherFormErrors() {
    let voucherFormGroup = document.getElementById('voucherFormGroup');
    let elements = document.getElementsByClassName('voucher-form-error');
    voucherFormGroup.classList.remove('has-error');

    for (let i = 0; i < elements.length; i++) {
        elements[i].classList.add('hidden');
    }
}

window.updateRates = function updateRates(summedPrice) {
    let formatter = Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });
    document.getElementById('dailyPriceHeader').innerHTML = formatter.format(summedPrice.originalPrice);

    document.getElementById('priceHeader').innerText = formatter.format(summedPrice.price);
    if (summedPrice.price === 0 && (summedPrice.maxApplicablePeriods === 0 || summedPrice.maxApplicablePeriods === null)) {
        document.getElementById('submitOrder').value = lang.pay_by_voucher;
    } else if (summedPrice.price === 0) {
        document.getElementById('submitOrder').value = lang.voucher_button;
        document.getElementById('voucher-help').style.visibility = 'visible';
    } else {
        document.getElementById('submitOrder').value = lang.book_for_price.replace(':price', formatter.format(summedPrice.price));
    }
    document.getElementById('fees').innerText = formatter.format(Math.max(0, summedPrice.serviceFee + summedPrice.transferFee));
    const priceElement = document.getElementById('price')
    if (priceElement) {
        priceElement.value = JSON.stringify(summedPrice.price);
    }
};

window.updateDurations = function updateDurations(duration, durationTimeUnit) {
    let durationElement = document.getElementById('coverageDuration');
    if (durationElement) {
        durationElement.innerText = duration;
    }

    let timeUnitElement = document.getElementById('durationTimeUnit');
    if (timeUnitElement) {
        timeUnitElement.innerText = assembleTimeUnitText(durationTimeUnit, parseInt(duration));
    }
};

window.updateVoucherField = function disableVoucherField(voucherCode) {
    document.getElementById('voucher').disabled = true;
    document.getElementById('voucher').value = voucherCode;
};

window.addDatePickers = function addDatePickers() {
    let ua = navigator.userAgent.toLowerCase();
    let dateInputs = document.querySelectorAll('input[type="date"]');
    Array.from(dateInputs).forEach(function (inputNode) {
        if (!(window.ActiveXObject) && "ActiveXObject" in window) {
            // IE browser
            generateDatePicker(inputNode);
        } else if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1) {
            // safari browser
            inputNode.setAttribute('placeholder', 'TT.MM.YYYY');
        } else if (ua.indexOf('firefox') !== -1) {
            inputNode.addEventListener('focus', function () {
                if (this.max && !this.value) {
                    this.value = this.max;
                }
            });
        }
    });
};

window.generateDatePicker = function generateDatePicker(node) {
    let maxDate = null;
    if (node.name === 'birthDate') {
        maxDate = moment().add(-18, 'Y');
    } else if (node.name === 'purchaseDate' || node.name === 'insure[birthDate]' || node.name === 'previousInsuranceCancelDate'
        || (node.name.indexOf('partner') !== -1 && node.name.indexOf('birthDate') !== -1)) {
        maxDate = moment();
    }

    return TinyDatePicker(node, {
        mode: 'dp-below',
        format(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        lang: lang.datepicker,
        dayOffset: 1,
        max: maxDate,
    }).on({
        select: function () {
            node.value = moment(node.value).format('DD.MM.YYYY');
        }
    });
};

window.catchEnter = function (call) {
    return function (e) {
        let key = e.which || e.keyCode;
        if (key === 13) {
            e.preventDefault();
            call();
        }
    }
};

window.isThankYouVoucherProductSlug = function (noThankYouVoucherProductSlugs, productName) {
    const name = productName.replaceAll('&amp;shy;', '').replaceAll('-', '').toLowerCase();
    for (const slug of noThankYouVoucherProductSlugs) {
        const product = slug.replaceAll('&amp;shy;', '').replaceAll('-', '').toLowerCase();
        if (name === product) {
            return false;
        }
    }
    return true;
};

// Used for the Country (Main Residence) dropdown menu in Checkout page
let selectField = document.getElementById('mainResidenceSelect');
if (selectField) {
    selectField.addEventListener('change', function () {
        this.classList.remove('error-field');
        let valueSelected = this.value;
        let el = document.getElementsByClassName('country-residence-item');

        for (let i = 0; i < el.length; i++) {
            el[i].className += ' hide';
        }

        if (valueSelected.includes(PRISMIC_PREFIX)) {
            let checkChildNodes = document.getElementById(valueSelected).childNodes.length;

            if (checkChildNodes !== 0) {
                document.getElementById(valueSelected).classList.remove('hide');
                $('#countryModal').modal('show');
            }
        }

        if (valueSelected === OTHER_COUNTRY_TEXT) {
            let otherCountry = document.getElementById(PRISMIC_PREFIX_OTHER_COUNTRY);
            if (otherCountry) {
                document.getElementById(PRISMIC_PREFIX_OTHER_COUNTRY).classList.remove('hide');
                $('#countryModal').modal('show');
            }
        }
    });
}

window.checkDeviceAgeExists = function () {
    let inputExists = true;
    DEVICE_AGE_INPUT_IDS.forEach(function (inputId) {
        if ($('#' + inputId).length == 0) inputExists = false;
    });

    if (inputExists) {
        let undamage = document.getElementById('undamagedConfirmed');
        undamage.parentElement.getElementsByClassName("attribute-text")[0].innerText = confirmDeviceAgeNew + '*';
    }
}

// Check if the correct associated Product Country has been selected,
window.checkMainResidenceField = function () {
    let disableInvoiceUser = document.getElementById('disableInvoiceUser');

    if (!disableInvoiceUser && (selectField.value === OTHER_COUNTRY_TEXT || selectField.value.includes(PRISMIC_PREFIX))) {
        selectField.classList.add('error-field');
        window.scrollTo({top: 0, behavior: 'smooth'});
        $('#countryModalAlert').modal('show');
    } else {
        return true;
    }
}


// Move Device Age confirmation text after the Multiple Model Inputs
let productCategory, productDuration;
let deviceAgeRadio = document.querySelectorAll('input[name="deviceAge"]')
let modelInputsSection = document.getElementById('model-inputs-section');
let deviceAgeConfirmText = document.getElementById('device-age-checkbox')
let deviceAgeConfirmInput = document.getElementById('undamagedConfirmed');
if (deviceAgeConfirmText) {
    if (modelInputsSection) {
        modelInputsSection.after(deviceAgeConfirmText);
    }
    deviceAgeRadio.forEach(radio => {
        if (radio.checked === true) {
            deviceAgeConfirmText.classList.remove('hidden');
        }
    });
    deviceAgeRadio.forEach(radio => radio.addEventListener('change', function () {
        // Uncheck confirm input text
        deviceAgeConfirmInput.checked = false;
        // Show confirm input text
        deviceAgeConfirmText.classList.remove('hidden');
    }));
}

// Show Duration Days Modal if device Age is OLD
document.addEventListener("DOMContentLoaded", function () {
    let submitOrderButton = document.getElementById('submitOrder');
    if (deviceAgeRadio && productCategory === BIKE_CATEGORY && productDuration === PRODUCT_DURATION_DAYS) {
        deviceAgeRadio.forEach(radio => radio.addEventListener('change', function () {
            if (document.getElementById(DEVICE_AGE_INPUT_IDS[1]).checked) {
                $('#durationDaysModal').modal('show');
                submitOrderButton.disabled = true;
            } else {
                submitOrderButton.disabled = false;
            }
        }));
    }
});

const chipnumberOfPetYes = document.querySelectorAll('input[name="chipnumberOfPet"]')[0];
const chipnumberOfPetNo = document.querySelectorAll('input[name="chipnumberOfPet"]')[1];
const chipnumberOfPetDependantAttributes = [
    document.querySelectorAll('input[name="chipnumberOfPet_text"]')[0]
];

const registrationNumberYes = document.querySelectorAll('input[name="registrationNumber"]')[0];
const registrationNumberNo = document.querySelectorAll('input[name="registrationNumber"]')[1];
const registrationNumberDependantAttributes = [
    document.querySelectorAll('input[name="registrationNumber_text"]')[0]
];

function yesAnswerAttribute(inputYes, Attributes) {
    inputYes.addEventListener('change', function () {
        Attributes.forEach(e => {
            if (e) {
                e.parentElement.classList.remove('hidden');
                e.required = true;
            }
        });
    });
}
if (chipnumberOfPetYes) {
    yesAnswerAttribute(chipnumberOfPetYes, chipnumberOfPetDependantAttributes);
}
if (registrationNumberYes) {
    yesAnswerAttribute(registrationNumberYes, registrationNumberDependantAttributes);
}
function noAnswerAttribute(attribute, noInput) {
    attribute.forEach(e => {
        if (e) {
            e.parentElement.classList.add('hidden');
            e.required = false;
            e.value = "";
        }
    });
    noInput.addEventListener('change', function () {
        attribute.forEach(e => {
            if (e) {
                e.parentElement.classList.add('hidden');
                e.required = false;
                e.value = "";
            }
        });
    });
}
if (chipnumberOfPetNo) {
    noAnswerAttribute(chipnumberOfPetDependantAttributes, chipnumberOfPetNo);
}
if (registrationNumberNo) {
    noAnswerAttribute(registrationNumberDependantAttributes, registrationNumberNo);
}



// hide further policy attributes if previous insurance was already canceled
const previouslyInsuredYes = document.querySelectorAll('input[name="previouslyInsured"]')[0];
const previouslyInsuredNo = document.querySelectorAll('input[name="previouslyInsured"]')[1];
const previouslyInsuredDependentAttributes = [
    document.getElementById('previousInsuranceCompany'),
    document.getElementById('previousInsuranceId'),
    document.getElementById('previousInsuranceCancelDate')
]
const previousInsuranceCancelledYes = document.querySelectorAll('input[name="previousInsuranceCancelled"]')[0];
const previousInsuranceCancelledNo = document.querySelectorAll('input[name="previousInsuranceCancelled"]')[1];
const dependentAttributes = [
    document.getElementById('previousInsuranceCancelDate')
]

if (previouslyInsuredYes) {
    previouslyInsuredYes.addEventListener('change', function () {
        previouslyInsuredDependentAttributes.forEach(e => {
            if (e) {
                e.parentElement.classList.remove('hidden');
                e.required = true;
            }
        });
        const previousInsuranceCancelledRadioButtons = document.querySelectorAll('input[name="previousInsuranceCancelled"]');
        if (previousInsuranceCancelledRadioButtons[0]) {
            previousInsuranceCancelledRadioButtons[0].parentElement.parentElement.parentElement.classList.remove('hidden');
        }
        previousInsuranceCancelledRadioButtons.forEach(e => e.required = true);
    });
}

if (previouslyInsuredNo) {
    previouslyInsuredDependentAttributes.forEach(e => {
        if (e) {
            e.parentElement.classList.add('hidden');
            e.required = false;
        }
    });
    document.querySelector('input[name="previousInsuranceCancelled"]').parentElement.parentElement.parentElement.classList.add('hidden');

    if (previouslyInsuredYes.checked == true) {
        document.querySelector('input[name="previousInsuranceCancelled"]').parentElement.parentElement.parentElement.classList.remove('hidden');
        previouslyInsuredDependentAttributes.forEach(e => {
            e.parentElement.classList.remove('hidden');
        });
        previouslyInsuredYes.click();
        if (previousInsuranceCancelledNo.checked == true) {
            dependentAttributes.forEach(e => {
                if (e) {
                    e.parentElement.classList.add('hidden');
                    e.required = false;
                }
            });
        }
    }

    previouslyInsuredNo.addEventListener('change', function () {
        if (previouslyInsuredYes.checked != true) {
            previouslyInsuredDependentAttributes.forEach(e => {
                if (e) {
                    e.parentElement.classList.add('hidden');
                    e.required = false;
                    e.value = "";
                }
            });
            document.querySelector('input[name="previousInsuranceCancelled"]').parentElement.parentElement.parentElement.classList.add('hidden');
            document.querySelectorAll('input[name="previousInsuranceCancelled"]').forEach(e => {
                e.required = false;
                e.checked = false;
            });
            previousInsuranceCancelledNo.checked = true;
        }
    });
}

if (previousInsuranceCancelledYes) {
    previousInsuranceCancelledYes.addEventListener('change', function () {
        dependentAttributes.forEach(e => {
            if (e) {
                e.parentElement.classList.remove('hidden');
                e.required = true;
            }
        });
    });
}

if (previousInsuranceCancelledNo) {
    document.getElementById('previousInsuranceCancelled_ja').removeAttribute('required');
    document.getElementById('previousInsuranceCancelled_nein').removeAttribute('required');
    previousInsuranceCancelledNo.addEventListener('change', function () {
        dependentAttributes.forEach(e => {
            if (e) {
                e.parentElement.classList.add('hidden');
                e.required = false;
            }
        });
    });
}

let checkCancellationInPast = document.getElementById('previousInsuranceCancelled');
if (checkCancellationInPast) {
    checkCancellationInPast.addEventListener('change', e => {
        if (e.target.checked === true) {
            document.getElementById('previousInsuranceCanceledBySelect').classList.remove('hidden');
            let selectedItem = document.getElementById('previousInsuranceCanceledByChoose');
            if (selectedItem) {
                let value = selectedItem.options[selectedItem.selectedIndex].value;
                if (value === 'insurer') {
                    $('#cancelledByInsurerModalAlert').modal('show');
                }
            }
            if (selectedItem) {
                selectedItem.addEventListener("change", e => {
                    let value = selectedItem.options[selectedItem.selectedIndex].value;
                    if (value === 'insurer') {
                        $('#cancelledByInsurerModalAlert').modal('show');
                    }
                })
            }
        } else {
            document.getElementById('previousInsuranceCanceledBySelect').classList.add('hidden');
        }
    });
}

// Check if insurance has not been cancelled by insurer during last 5 years else cancel submit
window.checkCancelledByInsurer = function () {
    let retVal = true
    let checkCancellationInPast = document.getElementById('previousInsuranceCancelled');
    let cancelledInThePast = checkCancellationInPast.checked;
    let cancelledBy = document.getElementById('previousInsuranceCanceledByChoose');
    let value = cancelledBy.options[cancelledBy.selectedIndex].value;
    if (cancelledInThePast && value === 'insurer') {
        selectField.classList.add('error-field');
        window.scrollTo({top: 500, behavior: 'smooth'});
        $('#cancelledByInsurerModalAlert').modal('show');
        retVal = false
    }
    return retVal
}

window.checkCountryAndCancelledByInsurer = function () {
    let checkCancellationInPast = document.getElementById('previousInsuranceCancelled');
    if (checkCancellationInPast) {
        if (checkCancelledByInsurer() && checkMainResidenceField()) {
            document.querySelectorAll('[disabled]').forEach(e => e.removeAttribute('disabled'));
            document.checkoutForm.submit();
        }
    } else if (checkMainResidenceField()) {
        document.querySelectorAll('[disabled]').forEach(e => e.removeAttribute('disabled'));
        document.checkoutForm.submit();
    }
}
